import { Product } from './product.model'

export class ProExpressProduct extends Product {
  buyingProgramName: string
  quantity: number
  quotecategoryName: string
}
